// extracted by mini-css-extract-plugin
module.exports = {"deliveryCrew":"TrackYourMovePanel_deliveryCrew__Wf8FI","callDriver":"TrackYourMovePanel_callDriver__GeH3c"};